import axios from 'axios';
import applyConverters from 'axios-case-converter';
import { ApiErrors } from '../main/constants/ApiErrors';
import { ROOT_URL, GET_BILLING_INFO_PATH } from '../main/constants/endpoints';
import { BillingInfo } from '../models/BillingInfo';

export const fetchBillingInfo = async (): Promise<BillingInfo> => {
    const client = applyConverters(axios.create());

    const response = await client.get(`${ROOT_URL}/${GET_BILLING_INFO_PATH}`, {
        withCredentials: true,
    });

    if (response?.data) {
        return response.data;
    }

    throw new Error(ApiErrors.NoResponseData);
};
